/**
 * Pull the first-paragraph preview from a markdown weekly summary.
 *
 * The v4 prompt produces three "## ..." sections, prose only. The body
 * of section 1 ("## What you did") is what we want for the calendar
 * inline preview. Falls back to the leading text when the heading is
 * missing — e.g. for an older summary generated by a prior prompt
 * version.
 */
export function previewFromSummary(summary: string): string {
  const firstHeader = summary.indexOf('## ');
  if (firstHeader === -1) {
    return summary.trim().slice(0, 240);
  }
  const afterFirstHeader = summary.indexOf('\n', firstHeader);
  if (afterFirstHeader === -1) {
    return summary.trim().slice(0, 240);
  }
  const nextHeader = summary.indexOf('## ', afterFirstHeader);
  const body = (
    nextHeader === -1
      ? summary.slice(afterFirstHeader)
      : summary.slice(afterFirstHeader, nextHeader)
  )
    .trim()
    .replaceAll(/\n+/g, ' ');
  return body.length > 280 ? `${body.slice(0, 280).trim()}…` : body;
}
